<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("partsmente.title_edit") }}</h1>
    <form>
      <b-card :title="this.$i18n.t('partsmente.label_serial')" class="w-50">
            <b-form-group
              id="serial"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_serial')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="serial" disabled=true :placeholder="this.$i18n.t('partsmente.placeholder_serial')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="code"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_code_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="code" :placeholder="this.$i18n.t('partsmente.placeholder_code')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="kind"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_kind')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="kind" :placeholder="this.$i18n.t('partsmente.placeholder_kind')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="maker"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('partsmente.label_maker')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="maker" :placeholder="this.$i18n.t('partsmente.placeholder_maker')" maxlength="60"></b-form-input>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("partsmente.button_update") }}</b-button>
            </div>
      </b-card>
    </form>
    <confirmModal modId="md-confirm" :msg="this.$i18n.t('partsmente.info_update')" :titleMsg="this.$i18n.t('partsmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      serial: null,
      code: null,
      kind: null,
      maker: null,
      efFlg: true,
      currentPage: 1,
      perPage: 5,
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      errMsg: null,
      errSbj: null
    }
  },
  methods: {
    search: function () {
      this.isSearch = !this.isSearch
    },
    regist: function () {
      // 入力値チェック
      if (this.code === null || this.code === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_code_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.code)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_code_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkAlphaNumSymbol(this.code)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_code_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.kind)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_kind_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.maker)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('partsmente.err_maker_symbol')
        this.$bvModal.show('md-err')
        return
      }

      // 空文字にして登録(「null」文字列が登録されることを避ける)
      if (this.kind == null) {
        this.kind = ''
      }
      if (this.maker == null) {
        this.maker = ''
      }

      // リクエスト
      var reqObj = {}
      reqObj.serial = this.serial
      reqObj.code = this.code
      reqObj.kind = this.kind
      reqObj.maker = this.maker

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/parts/update', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })
    this.serial = this.$store.store.state.serial
    this.code = this.$store.store.state.code
    this.kind = this.$store.store.state.kind
    this.maker = this.$store.store.state.maker
    console.log(this.from)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PartsmenteEdit.vue